import React, { ReactNode } from "react";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import Drawer from "@vapor/react-material/Drawer";
import { VaporIcon } from "@vapor/react-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { useDrawerStore } from "../../context/DrawerContext/index.ts";

interface ServicesDrawerProps {
  children: ReactNode;
  icon: IconDefinition;
  drawerName: string | null;
}

export const ServicesDrawer: React.FC<ServicesDrawerProps> = ({
  children,
  icon,
  drawerName,
}) => {
  const { open, setOpen } = useDrawerStore();

  const handleDrawer = () => {
    setOpen(open === drawerName ? null : drawerName);
    if (!open) {
      const activeElement = document.activeElement as HTMLElement;
      activeElement.blur();
    }
  };
  return (
    <Box sx={{ display: "flex", position: "relative", m: 1 }}>
      <Button
        sx={{
          backgroundColor: open === drawerName ? "#008FD6" : "none",
          "&:hover": {
            backgroundColor: "#008FD6",
          },
        }}
        onClick={handleDrawer}
      >
        <VaporIcon icon={icon} color="inverse" size="20px" />
      </Button>
      <Drawer
        anchor="right"
        open={open == drawerName}
        onClose={handleDrawer}
        // hideBackdrop
        width={620}
      >
        {children}
      </Drawer>
    </Box>
  );
};
